module.exports = __webpack_public_path__ + "static/media/20ECE26.86928f5d.jpg";